import { Stack, Typography } from "@mui/material";
import { Position } from "@xyflow/react";

import type { FilterRuleNode, RuleNodeProps } from "../types/nodes";
import AddHiddenHandle from "./AddHiddenHandle";
import BaseNode from "./BaseNode";

type FilterNodeProps = RuleNodeProps<FilterRuleNode>;

const FilterNode = (props: FilterNodeProps) => {
	const { data } = props;
	const conditions = data.conditions ?? [];

	return (
		<BaseNode {...props}>
			<Stack spacing={1.25}>
				{conditions.length ? (
					<Stack spacing={0.5}>
						{conditions.map((condition, index) => {
							const fieldDisplay = condition.field || condition.databaseTableFieldId || condition.screenTableFieldId || "";
							return (
								<Typography
									variant="body2"
									color="text.primary"
									key={`${fieldDisplay}-${index}`}
								>
									{index + 1}. {fieldDisplay} {condition.operator} {String(condition.value)}
								</Typography>
							);
						})}
					</Stack>
				) : (
					<Typography variant="body2" color="text.disabled">
            No filters configured
					</Typography>
				)}
			</Stack>
			<AddHiddenHandle
				type="target"
				position={Position.Top}
				id="in"
			/>
		</BaseNode>
	);
};

export default FilterNode;
